import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
// [GEMINI EDIT] 1. Import setAuthToken
import { setAuthToken } from "@/utils/adminApi";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// [GEMINI EDIT] 2. ตั้งค่า Token ทันทีที่เปิดแอป
const token = localStorage.getItem("admin_token");
if (token) {
  setAuthToken(token);
}

app.mount("#app");
